<template>
  <div class="goodsTable">
    <!-- 运输载具数据表格 -->
    <vxe-toolbar v-if="$route.query.returnStatus == 2">
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="insertEvent(-1)"
          >{{ $t('detailOrAcceptCredit.btnList.add') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="handleDelete('goodsTable')"
          >{{ $t('detailOrAcceptCredit.btnList.remove') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      resizable
      show-overflow
      :data="goodsData"
      :edit-config="editConfig"
      size="mini"
      ref="goodsTable"
      :edit-rules="goodsTableEditRules"
      auto-resize
      show-footer
      :footer-method="footerMethod"
    >
      <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
      <!-- 序号 -->
      <vxe-table-column
        type="seq"
        width="60"
        field="indexTitle"
        :title="$t('detailOrAcceptCredit.goodsTable.indexTitle')"
      ></vxe-table-column>
      <!-- 合同号 -->
      <vxe-table-column
        field="contractNo"
        :title="this.$t('detailOrAcceptCredit.goodsTable.contractNo')"
        :edit-render="{
          name: 'input',
          defaultValue: '',
        }"
      >
        <template v-slot:edit="scope">
          <search-table
            searchType="contract"
            :isMultiple="true"
            :extraData="contractInfo"
            :currentValue="scope.row['contractNo']"
            :checkRowKeys="[scope.row['contractNo']]"
            @input="(val) => chooseTable(val, scope.row, 'contractNo', scope)"
          ></search-table>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column
        field="projectCode"
        title="项目"
        :edit-render="{
          name: 'ElInput',
          props: { clearable: true },
        }"
      >
        <template v-slot:default="scope">
          {{ scope.row['projectName'] }}
        </template>
        <template v-slot:edit="scope">
          <search-table
            searchType="project"
            :isMultiple="true"
            :currentValue="scope.row['projectName']"
            :checkRowKeys="[scope.row['projectCode']]"
            @input="(val) => chooseTable(val, scope.row, 'projectCode', scope)"
          ></search-table>
        </template>
      </vxe-table-column> -->

      <!-- 外部合同号 -->
      <!-- <vxe-table-column
        field="externalContractNo"
        :title="this.$t('detailOrAcceptCredit.goodsTable.externalContractNo')"
      ></vxe-table-column> -->
      <!-- 项目 -->
      <vxe-table-column
        field="projectName"
        :title="this.$t('detailOrAcceptCredit.goodsTable.projectName')"
      ></vxe-table-column>
      <!-- 客户 -->
      <vxe-table-column
        field="customerName"
        :title="this.$t('detailOrAcceptCredit.goodsTable.customerName')"
      ></vxe-table-column>
      <!-- 业务员 -->
      <vxe-table-column
        field="contractSalesmanName"
        :title="this.$t('detailOrAcceptCredit.goodsTable.contractSalesmanName')"
      ></vxe-table-column>
      <!-- 认领金额 -->
      <vxe-table-column
        field="issueAmount"
        :title="this.$t('detailOrAcceptCredit.goodsTable.issueAmount')"
        :edit-render="{
          name: 'input',
          defaultValue: '',
        }"
      >
        <template v-slot:edit="scope">
          <input-number
            v-model="scope.row['issueAmount']"
            :max="999999999.999999"
            :min="0"
            @input="changeIssueAmount"
          ></input-number>
        </template>
      </vxe-table-column>
    </vxe-grid>
  </div>
</template>
<script>
  // import { mapState } from 'vuex';
  import SearchTable from '@/components/form-item/search-table';
  import InputNumber from '@/components/form-item/input-number';
  // import GOODS_API from '@/api/masterData/goods';
  // import COOPERATION_API from '@/api/masterData/cooperation';
  // import MASTER_API from '@/api/masterData/company.js';
  // import API from '@/api/purchaseSalesCenter/purchaseSales.js';
  // import { resolve, reject } from 'q';
  // import { dateFormatter } from '@/common/js/util';

  export default {
    name: 'GoodsTable',
    components: {
      SearchTable,
      InputNumber,
    },
    data() {
      return {
        calculateIssuingAmount: 0,
        contractInfo: {
          contractStatus: 'ZT03',
          contractCategory: 'sales',
          companyCode: null,
          departmentCode: null,
          // customerNo: null,
        },
        goodsData: [],
        delContractList: [],
        editConfig: {
          trigger: 'click',
          mode: 'row',
          showStatus: true,
          activeMethod: this.activeRowMethod,
        },
      };
    },
    computed: {
      goodsTableEditRules() {
        return {
          contractNo: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.goodsTableEditRules.contractNo'),
            },
          ],
          issueAmount: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.goodsTableEditRules.issueAmount'),
            },
          ],
          customerName: [
            {
              required: true,
              message: '请选择客户名称',
            },
          ],
          // contractSalesmanName: [
          //   {
          //     required: true,
          //     message: '请选择业务员名称',
          //   },
          // ],
        };
      },
      totalText() {
        return this.$t('detailOrAcceptCredit.goodsTable.totalText');
      },
    },
    methods: {
      activeRowMethod() {
        //禁用编辑
        if (this.$route.query.returnStatus && this.$route.query.returnStatus != 2) {
          return false;
        }
        return true;
      },
      changeIssueAmount() {
        this.$refs.goodsTable.updateFooter();
      },
      // 表尾合计
      footerMethod({ columns, data }) {
        if (data.length == 0) {
          return [];
        } else {
          return [
            columns.map((column, columnIndex) => {
              if (columnIndex === 0) {
                return this.$t('xTable.total');
              }
              if (['issueAmount'].includes(column.property)) {
                this.calculateIssuingAmount = data
                  .map((i) => i['issueAmount'])
                  .reduce((acc, cur) => {
                    const num = this.$cal.calCommon(acc, cur, '+');
                    return num;
                  }, 0);
                return this.calculateIssuingAmount;
              }
              return null;
            }),
          ];
        }
      },
      // 载具表格新增一行
      insertEvent(row) {
        this.$refs.goodsTable.validate().then(() => {
          // if (valid) {
          this.$nextTick(() => {
            let formData = this.$parent.$parent.$parent.$refs.baseForm.baseData;
            this.contractInfo.companyCode = formData.companyCode;
            this.contractInfo.departmentCode = formData.departmentCode;
            // this.contractInfo.customerNo = formData.partnerCode;
          });
          let record = {
            contractNo: null,
            externalContractNo: null,
            customerName: null,
            contractSalesmanName: null,
            issueAmount: 0,
          };
          this.$refs.goodsTable.insertAt(record, row).then(({ row }) => {
            this.$refs.goodsTable.setActiveRow(row);
          });
          // }
        });
      },
      handleDelete(goodsTable) {
        const selectedList = this.$refs[goodsTable].getCheckboxRecords();
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('returnDetail.msg.removeMsg'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              if (item.id) {
                this.delContractList.push(item.id);
              }
            });
            this.$refs[goodsTable].removeSelecteds();
            this.goodsData = this.$refs[goodsTable].getTableData().fullData;
            this.$refs[goodsTable].updateFooter();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('personnel.table.deletSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('personnel.table.deletFalse'),
            });
          });
      },
      //获取值
      chooseTable(val, row, field, scope) {
        if (field == 'contractNo') {
          row.contractNo = val[0].contractNo;
          row.projectName = val[0].projectName;
          row.projectNo = val[0].projectNo;
          row.externalContractNo = val[0].externalContractNo || '';
          row.customerNo = val[0].customerNo || '';
          row.customerName = val[0].customerName || '';
          row.contractSalesmanName = val[0].contractSalesmanName || '';
        }
        // else if (field == 'projectCode') {
        //   console.log(val);
        //   console.log(row);
        //   if (val && val.length > 0) {
        //     row['projectName'] = val[0].projectName;
        //     row['projectCode'] = val[0].projectCode;
        //   } else {
        //     row['projectName'] = null;
        //     row['projectCode'] = null;
        //   }
        // }
        this.$refs.goodsTable.updateStatus(scope);
      },
    },
  };
</script>
